var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.016 15.376L15.312 16.08L11.232 12L15.312 7.92L16.016 8.624L13.136 11.504H20V12.496H13.136L16.016 15.376ZM6 6H10.672V18H6V6ZM19.008 19.008V16.496H20V19.008C20 19.2747 19.904 19.504 19.712 19.696C19.52 19.8987 19.2853 20 19.008 20H5.008C4.73067 20 4.49067 19.904 4.288 19.712C4.096 19.52 4 19.2853 4 19.008V4.992C4 4.71467 4.096 4.48 4.288 4.288C4.49067 4.096 4.73067 4 5.008 4H19.008C19.2853 4 19.52 4.096 19.712 4.288C19.904 4.48 20 4.71467 20 4.992V7.504H19.008V4.992H5.008V19.008H19.008Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.3b75b66f7095ccc8802ead58a0c022fe.svg";
export { ForwardRef as ReactComponent };